import React, { Component } from 'react';
import './collapse.css';
import { BiChevronDown } from "react-icons/bi";



export default class Collapse extends Component {
	constructor(props) {
		super(props);
		this.state = {
			display: this.props.initiallyCollapsed ? 'none' : 'block'
		}
	}

	functionName = (e) => {
		let id = e.target.id
		this.setState({
			display: id == this.props.id ? (this.state.display == 'none' ? 'block' : 'none')
				: ''
		})
	}
	render() {

		return (
			<div className="mt-2" style={{width:'100%',border:'1px solid #ced4da', borderRadius:'6px', padding:'10px'}}>
					<div className='hover-class' style={{display: 'flex', alignItems: 'center' }} id={this.props.id} onClick={this.functionName}>
						<div className="">
							<div className="bg-white separator weight-500" style={{ color: 'var(--cyan-800, #155B75)', whiteSpace: 'nowrap', fontSize:'16px', fontWeight:'500' }} id={this.props.id}>{this.props.title}</div>
						</div>
						<div style={{ height:'0.5px' , width:'100%' , margin:'0px 10px 0px 10px' }}>
						</div>
					<div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
				
							<div className="status-icon-wrapper">
							{this.props.agentIcon && (
								<div className="status-icon-block">
									<div className="status-label">A</div>
									<div>{this.props.agentIcon}</div>
								</div>)}
								{this.props.tenantIcon && (
								<div className="status-icon-block">
									<div className="status-label">T</div>
									<div>{this.props.tenantIcon}</div>
								</div>)}
							</div>
						<img
							onClick={this.functionName}
							id={this.props.id}
							className={(this.state.display == 'none') ? 'rotate-down hover-class' : 'rotate hover-class'}
							src={'../assets/images/icon.png'}
							width="17"
							style={{ marginTop: '-3.3px' }}
						/>
					</div>

						
					</div>
					<br />
					{this.state.display === 'block' && (
					<div className={`col-12 px-0 collapse-content ${this.state.display === 'none' ? 'collapsed' : 'expanded'}`}>
					{this.props.data}
				</div>)}

				<div className="">
				{this.state.display === 'block' && (
					<div className="row" >
						<div className="col-md-1">
						</div>
						<div className="col-md-10 text-right" style={{ fontSize:'12px',display: this.state.display }}>
							{this.props.actionData}
                        
						</div>
						<div className="col-md-1">
						</div>
					</div>)}
				</div>
			</div>
		);
	}
}